import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";
import { loaderService } from "../loaderService";

const url = GlobalConstants.urlApi;

const getSegmentaciones = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/segmentaciones/getSegmentaciones`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getSegmentacionesNombres = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/segmentaciones/getSegmentacionesNombres`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveSegmentacionManual = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/segmentaciones/saveSegmentacionManual`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateSegmentacionManual = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/segmentaciones/updateSegmentacionManual`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateEstadoSegmentacion = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/segmentaciones/updateEstadoSegmentacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const validateAsignacionSegmentacion = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/segmentaciones/validateAsignacionSegmentacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const deleteSegmentacion = (data) => {
    loaderService.showLoader({ label: "Cargando..." });
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/segmentaciones/deleteSegmentacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getSegmentacionClientes = (data) => {
    loaderService.showLoader({ label: "Cargando..." });
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/segmentaciones/getSegmentacionClientes`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getClientesDisponibles = (data) => {   
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/segmentaciones/getClientesDisponibles`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const validarExcelClientes = (data) => {    
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/unoauno/segmentaciones/validarExcelClientes`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveClientsSegmentacion = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/segmentaciones/saveClientsSegmentacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getVersionesApp = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/unoauno/segmentaciones/getVersionesApp`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveSegmentacionAutomatica = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/segmentaciones/saveSegmentacionAutomatica`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const segmentacionesService = {
    getSegmentacionesNombres,
    getSegmentaciones,
    saveSegmentacionManual,
    updateSegmentacionManual,
    updateEstadoSegmentacion,
    validateAsignacionSegmentacion,
    deleteSegmentacion,
    getSegmentacionClientes,
    getClientesDisponibles,
    validarExcelClientes,
    saveClientsSegmentacion,
    getVersionesApp,
    saveSegmentacionAutomatica
};